import React, { useEffect, useState } from 'react';
import Portal from './portal-view'; // Ensure the Portal component is in the same directory or adjust the import path accordingly
import { IDSSModal } from '../../building-blocks/DSSFramework';





const DLSModal = (props: IDSSModal) => {


    const [isModalOpen, setIsModalOpen] = useState(props.isOpen);
    useEffect(() => {
        setIsModalOpen(props.isOpen);
    }, [props.isOpen]);
    const closeModal = () => {
        if (props.onClose) {
            props.onClose();
        }
        setIsModalOpen(false);
    };


    const handleOverlaycloseModal = (e: React.SyntheticEvent<HTMLDivElement>) => {
        if (props.enableOberlayTap) {
            closeModal();
        }
        e.stopPropagation();
    };


    const modalStyle = {
        position: 'fixed',
        zIndex: 1000,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'grid',
        justifyContent: 'center',
        alignItems: 'center',
        placeItems: 'center'

    } as React.CSSProperties;

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        padding: '8px 20px',
        width: 'fit-content',
        minWidth: "30vw",
        textAlign: 'center',
        borderRadius: '4px',
    } as React.CSSProperties;

    const closeButtonStyle = {
        color: "#000000",
        float: "right",
        fontSize: "2.5rem",
        fontWeight: "bold",
        cursor: "pointer",
        height: "22px",
        overflow: "hidden",
        textAlign: "center",
        lineHeight: "22px",
        marginTop: "1rem"
    } as React.CSSProperties;


    const heading = {
        width: "100%",
        marginTop: "3rem",
        fontSize: "20px",
        color :"#1E1E25",
        fontWeight: "700",
        textAlign: "left",
    } as React.CSSProperties

    const desc = {
        width: "100%",
        marginTop: "1rem",
        fontSize: "16px",
        fontWeight: "500",
        textAlign: "left",
        
    } as React.CSSProperties

    return (
        <div>

            {isModalOpen && (
                <Portal>
                    <div style={{ ...modalStyle }} onClick={handleOverlaycloseModal} className={`dss-modalcontainer ${props.className ?? ''}`}>

                        <div className='dss-modalcontent' style={{ ...modalContentStyle, ...props.style }} onClick={(e: React.SyntheticEvent<HTMLDivElement>) => {
                            e.stopPropagation();
                        }}>
                            {props.isShowClose && <div className='dss-closebutton' style={closeButtonStyle} onClick={closeModal}>&times;</div>}
                            {props.heading && <div className='dss-heading' style={heading}>{props.heading} </div>}
                            {props.desc && <div className='dss-description' style={desc}>{props.desc} </div>}
                            {props.heading && <hr />}
                            {props.children}
                        </div>
                    </div>
                </Portal>
            )}
        </div>
    );
};

export default DLSModal;